export default __webpack_public_path__ + "7de8917eb83a0af0175f3c33b4038589.ttf";